//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BindSupplierVue from '../dialogs/BindSupplier.vue';
import { customerSuppliersApi, deleteSupplierApi } from '../../../api';
export default {
  name: 'Supplier',
  components: {
    BindSupplierVue: BindSupplierVue
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      bindSupplierVueRef: null,
      tableData: {
        list: []
      }
    };
  },
  methods: {
    openSupplier: function openSupplier(row) {
      this.bindSupplierVueRef.open(row);
    },
    getSuppliers: function getSuppliers() {
      var _this = this;
      customerSuppliersApi(this.id).then(function (res) {
        _this.tableData = res || {
          list: []
        };
      });
    },
    deleteRecord: function deleteRecord(row) {
      var _this2 = this;
      deleteSupplierApi(row).then(function () {
        _this2.$message.success('移除成功');
        _this2.getSuppliers();
      });
    }
  },
  mounted: function mounted() {
    this.bindSupplierVueRef = this.$refs.bindSupplierVueRef;
    this.getSuppliers();
  },
  watch: {
    id: function id(newVal) {
      if (newVal) {
        this.getSuppliers();
      }
    }
  }
};